import gql from 'graphql-tag';

// This is used in Inbox page
export const SubscribeToAssociateMessageNotificationCreated = gql`
  subscription onAssociateMessageNotificationCreated($associateId: String!) {
    onAssociateMessageNotificationCreated(associateId: $associateId) {
      associateId
      contactId
      contactName
      notificationCount
      message_inbox_status
      last_message
      message_type
      message_subject
      last_date_created
      conversationId
      internalAddress
      sourceId
      direction
      externalEntityId
      externalEntityName
      platformMessageId
      externalAddress
      tags
      messageId
      callDuration
      callEndTimestamp
      callStartTimestamp
      callStatus
    }
  }
`;

// This is used in Inbox page
export const SubscribeToAssociateMessageNotificationUpdated = gql`
  subscription onAssociateMessageNotificationUpdated($associateId: String!) {
    onAssociateMessageNotificationUpdated(associateId: $associateId) {
      associateId
      contactId
      last_message
      last_date_created
      message_inbox_status
      message_type
      message_subject
      contactName
      notificationCount
    }
  }
`;

// This is used in Inbox page
export const SubscribeToAssociateMessageMark = gql`
  subscription onAssociateMessageMark($associateId: String!) {
    onAssociateMessageMark(associateId: $associateId) {
      associateId
      contactId
      last_message
      last_date_created
      message_inbox_status
      message_type
      message_subject
      contactName
      notificationCount
    }
  }
`;

// This is used in Conversation page
export const SubscribeToMessageCreatedConversation = gql`
  subscription onMessageCreatedConversation($associateId: String!, $contactId: String!) {
    onMessageCreatedConversation(associateId: $associateId, contactId: $contactId) {
      message_status
      associateId
      contactId
      message_direction
      message_type
      message_subject
      date_created
      messageId
      message
    }
  }
`;

// This is used in Conversation page
export const SubscribeToUpdateStatusConversation = gql`
  subscription onUpdateStatusConversation($associateId: String!, $contactId: String!) {
    onUpdateStatusConversation(associateId: $associateId, contactId: $contactId) {
      message_status
      associateId
      contactId
      message_direction
      message_subject
      date_created
      messageId
      message
    }
  }
`;

// This is used in Conversation page
export const SubscribeToMessageMarkedReadConversation = gql`
  subscription onMessageMarkedReadConversation {
    onMessageMarkedReadConversation {
      associateId
      messageId
      contactId
    }
  }
`;

// This is used to mark messages as read / unread
export const SubscribeToMessageMark = gql`
  subscription {
    onMessageMark {
      associateId
      contactId
    }
  }
`;

// This is used in GlobalNav for alert notifications
export const SubscribeToReadNotificationCounts = gql`
  subscription onNotificationCountRead($associateId: String!) {
    onNotificationCountRead(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for alert notifications
export const SubscribeToCreateNotification = gql`
  subscription onNotificationCountCreated($associateId: String!) {
    onNotificationCountCreated(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in GlobalNav for alert notifications
export const SubscribeToUpdatedNotificationCount = gql`
  subscription onNotificationCountUpdated($associateId: String!) {
    onNotificationCountUpdated(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in NotificationList
export const SubscribeToCreateEvents = gql`
  subscription onEventCreated($associateId: String!) {
    onEventCreated(associateId: $associateId) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
      message
      customerId
    }
  }
`;

// This is used on HomePage and Conversations Page
export const SubscribeToAssociateStatus = gql`
  subscription {
    onAssociateStatusUpserted {
      associateStatus
    }
  }
`;

// This is used in Client Online Bag Tab for READ alert notifications
export const SubscribeToReadOnlineBagNotificationCounts = gql`
  subscription onOnlineBagNotificationCreatedSubscription($associatePin: String!) {
    onOnlineBagNotificationCreated(associatePin: $associatePin) {
      associatePin
      notificationCount
    }
  }
`;

//This is being used over Instore Checkout page
export const SubscribeToPayment = gql`
  subscription onPaymentUpserted($associateId: String!) {
    onPaymentUpserted(associateId: $associateId) {
      associateId
      paymentId
      paymentStatus
      paymentType
      errorMessage
    }
  }
`;
